import {
  FiHome,
  FiEdit3,
  FiBriefcase,
  FiCompass,
  FiHeart,
  FiFolder,
  FiUsers,
  FiUser,
  FiKey,
  FiTrendingUp,
  FiGrid,
  FiBookOpen,
  FiCreditCard,
  FiLayers,
} from "react-icons/fi";

const createItem = (item) => ({
  ...item,
  activePrefixes: item.activePrefixes ?? [item.to],
});

export const PARTNER_PANEL_HOME = "/partner/workspace";

export const partnerSidebarSections = [
  {
    id: "overview",
    title: "Overview",
    items: [
      {
        to: "/partner/workspace",
        label: "Dashboard",
        icon: FiHome,
        activePrefixes: ["/partner/workspace", "/partner/dashboard", "/partner/myspace"],
      },
    ],
  },
  {
    id: "tools",
    title: "Business Tools",
    items: [
      {
        to: "/partner/tools",
        label: "Tools Hub",
        icon: FiGrid,
        activePrefixes: ["/partner/tools"],
      },
      {
        to: "/partner/tools/khatabook",
        label: "Khatabook",
        icon: FiBookOpen,
        activePrefixes: ["/partner/tools/khatabook"],
      },
      {
        to: "/partner/tools/cashbook",
        label: "Cashbook",
        icon: FiCreditCard,
        activePrefixes: ["/partner/tools/cashbook"],
      },
      {
        to: "/partner/tools/projects",
        label: "Project Ledger",
        icon: FiLayers,
        activePrefixes: ["/partner/tools/projects"],
      },
      {
        to: "/partner/tools/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/partner/tools/leases", "/partner/leases"],
      },
    ],
  },
  {
    id: "shared",
    title: "Shared",
    items: [
      {
        to: "/partner/posts",
        label: "Shared Posts",
        icon: FiEdit3,
        activePrefixes: ["/partner/posts"],
      },
      {
        to: "/partner/properties",
        label: "Shared Properties",
        icon: FiBriefcase,
        activePrefixes: ["/partner/properties"],
      },
      {
        to: "/partner/promotions",
        label: "Shared Promotions",
        icon: FiTrendingUp,
        activePrefixes: ["/partner/promotions"],
      },
      {
        to: "/partner/shared-leads",
        label: "Shared Leads",
        icon: FiCompass,
        activePrefixes: ["/partner/shared-leads"],
      },
    ],
  },
  {
    id: "myspace",
    title: "My Space",
    items: [
      {
        to: "/partner/my-properties",
        label: "My Properties",
        icon: FiBriefcase,
        activePrefixes: ["/partner/my-properties"],
      },
      {
        to: "/partner/my-posts",
        label: "My Posts",
        icon: FiEdit3,
        activePrefixes: ["/partner/my-posts"],
      },
      {
        to: "/partner/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/partner/leases"],
      },
      {
        to: "/partner/saved",
        label: "Following",
        icon: FiHeart,
        activePrefixes: ["/partner/saved", "/partner/following"],
      },
      {
        to: "/partner/shared-with-me",
        label: "Shared with Me",
        icon: FiFolder,
        activePrefixes: ["/partner/shared-with-me"],
      },
    ],
  },
  {
    id: "people",
    title: "People",
    items: [
      {
        to: "/partner/network",
        label: "Network Partners",
        icon: FiUsers,
        activePrefixes: ["/partner/network", "/partner/agents"],
      },
      {
        to: "/partner/friends",
        label: "Customers & Friends",
        icon: FiUser,
        activePrefixes: ["/partner/friends"],
      },
      {
        to: "/partner/teams",
        label: "Partner Teams",
        icon: FiLayers,
        activePrefixes: ["/partner/teams"],
      },
    ],
  },
].map((section) => ({
  ...section,
  items: section.items.map(createItem),
}));

export const getPartnerPageTitle = (pathname) => {
  const allItems = partnerSidebarSections.flatMap((s) => s.items);
  const found = allItems.find((item) =>
    item.activePrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
  );
  return found?.label ?? "Partner Dashboard";
};

const partnerNavigation = {
  sections: partnerSidebarSections,
};

export default partnerNavigation;
